/**
 * Copyright © Veeam Software Group GmbH.
 */

export const areSetsEqual = <T>(set1: Set<T>, set2: Set<T>): boolean => (
    set1.size === set2.size && [...set1].every(element => set2.has(element))
);
